import { PatientStore } from './PatientStore.ts';
import { RouteStore } from './RouteStore.ts';

export const patientStore = new PatientStore();
export const routeStore = new RouteStore();

export const stores = {
    patientStore,
    routeStore,
};
